/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompleteSortieCommand } from './completeSortieCommand';
import { MissionCrewDto } from './missionCrewDto';
import { UpdateLocationFeaturesCommand } from './updateLocationFeaturesCommand';

/**
 * Command for creating a new historical mission
 */
export interface CreateRetrospectiveMissionCommand {
    organisationId: number;
    name: string;
    missionDate?: string;
    timeZone?: string;
    missionTypeId?: number;
    /**
     * Which workgroup is this mission associated with
     */
    workgroupId?: number;
    /**
     * Which project is this mission associated with
     */
    projectId?: number;
    /**
     * The mission workflow being used for this mission
     */
    missionWorkflowVersionId?: number;
    missionObjective?: string;
    /**
     * The mission object type ID
     */
    missionObjectiveTypeId?: number;
    craftIds: Array<number>;
    equipmentIds: Array<number>;
    missionCrew: Array<MissionCrewDto>;
    locationId?: number;
    /**
     * The visual line of sight option of mission
     */
    visualLineOfSight?: CreateRetrospectiveMissionCommand.VisualLineOfSight;
    /**
     * The time in which mission occur
     */
    timeOfDay?: CreateRetrospectiveMissionCommand.TimeOfDay;
    /**
     * Create a mission\'s location as part of the mission creation process.
     */
    location?: UpdateLocationFeaturesCommand;
    /**
     * The outcome of the objectives of this mission
     */
    outcome?: CreateRetrospectiveMissionCommand.Outcome;
    /**
     * Notes about the objective outcome that was achieved
     */
    objectiveOutcomeNotes?: string;
    /**
     * The message that is recorded about the entire mission
     */
    completionMessage?: string;
    /**
     * The sorties that make up this mission
     */
    sorties: Array<CompleteSortieCommand>;
}
export namespace CreateRetrospectiveMissionCommand {
    export type VisualLineOfSight = 'VLOS' | 'EVLOS' | 'BVLOS';
    export const VisualLineOfSight = {
        VLOS: 'VLOS' as VisualLineOfSight,
        EVLOS: 'EVLOS' as VisualLineOfSight,
        BVLOS: 'BVLOS' as VisualLineOfSight
    };
    export type TimeOfDay = 'DAY' | 'NIGHT' | 'DAY_NIGHT';
    export const TimeOfDay = {
        DAY: 'DAY' as TimeOfDay,
        NIGHT: 'NIGHT' as TimeOfDay,
        DAY_NIGHT: 'DAY_NIGHT' as TimeOfDay
    };
    export type Outcome = 'COMPLETED' | 'PARTIALLY_COMPLETED' | 'INCOMPLETE';
    export const Outcome = {
        COMPLETED: 'COMPLETED' as Outcome,
        PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED' as Outcome,
        INCOMPLETE: 'INCOMPLETE' as Outcome
    };
}
